import { formatDateTime, formatShortDateWithWeekday } from "@clipboard-health/date-time";
import { Text, useModalState } from "@clipboard-health/ui-react";
import { isDefined } from "@clipboard-health/util-ts";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Collapse, Grid, IconButton, TableCell, TableRow } from "@mui/material";
import {
  type AttendaceScoreLog,
  attendanceScoreActionLabelMap,
} from "@src/appV2/AttendanceScore/api/useGetAttendanceScoreHistory";

export function AttendanceScoreHistoryRowItem(props: { scoreLog: AttendaceScoreLog }) {
  const { scoreLog } = props;
  const collapseState = useModalState();

  return (
    <>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        onClick={() => {
          if (collapseState.modalIsOpen) {
            collapseState.closeModal();
          } else {
            collapseState.openModal();
          }
        }}
      >
        <TableCell sx={{ padding: "8px" }}>
          {formatShortDateWithWeekday(scoreLog.createdAt)}
        </TableCell>
        <TableCell sx={{ padding: "8px" }}>
          {attendanceScoreActionLabelMap.get(scoreLog.action) ?? scoreLog.action}
        </TableCell>
        <TableCell sx={{ color: scoreLog.points >= 0 ? "green" : "red", padding: "0px" }}>
          {scoreLog.points}
        </TableCell>
        <TableCell sx={{ padding: "0px" }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => {
              if (collapseState.modalIsOpen) {
                collapseState.closeModal();
              } else {
                collapseState.openModal();
              }
            }}
          >
            {collapseState.modalIsOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse
            unmountOnExit
            sx={{ paddingBottom: "8px", paddingTop: "8px" }}
            in={collapseState.modalIsOpen}
          >
            <Grid container spacing={0.5}>
              {isDefined(scoreLog.shiftStart) && (
                <>
                  <Grid item xs={3}>
                    <Text variant="body2">Shift Time:</Text>
                  </Grid>
                  <Grid item xs={9}>
                    <Text variant="body2" align="right">
                      {formatDateTime(scoreLog.shiftStart)}
                    </Text>
                  </Grid>
                </>
              )}

              {isDefined(scoreLog.facilityName) && (
                <>
                  <Grid item xs={3}>
                    <Text variant="body2">Location:</Text>
                  </Grid>
                  <Grid item xs={9}>
                    <Text variant="body2" align="right">
                      {scoreLog.facilityName}
                    </Text>
                  </Grid>
                </>
              )}

              <Grid item xs={3}>
                <Text variant="body2">New Score:</Text>
              </Grid>
              <Grid item xs={9}>
                <Text variant="body2" align="right">
                  {scoreLog.score}
                </Text>
              </Grid>
            </Grid>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
